<template>
  <div class="main-container">
    <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
      <v-card min-width="300px" min-height="100px">
        <div class="menu-container">
          <div class="menu-container-title">
            «Состав консультационного совета акционеров»
          </div>
          <div class="menu-container-text">
            Список акционеров, который отображается в мобильном приложении
          </div>
        </div>
      </v-card>
    </v-menu>

    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Техническая поддержка </span>
        <!-- <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false" color="var(--app-dark-blue-1)">mdi-information</v-icon> -->
      </div>
      <v-btn @click="goToCreateSupport" style="width: auto !important" class="button-accept">
        + Добавить контакт
      </v-btn>
    </div>
    <div style="height: calc(100vh - 190px); overflow: auto">
      <v-data-table :headers="supportHeaders" :items="supports" item-key="id" :show-select="false"
        :disable-pagination="true" :hide-default-footer="true" :hide-default-header="true">
        <template v-slot:header>
          <thead>
            <tr>
              <th v-for="(s, index) in supportHeaders" :key="index">
                <div style="margin-left: 24px" v-if="s.text == 'Название контакта'">
                  {{ s.text }}
                </div>
                <div style="max-width: 100px !important" v-else-if="s.text == 'Порядок отображения'">
                  {{ s.text }}
                </div>
                <div v-else>
                  {{ s.text }}
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="props">
          <draggable :list="props.items" tag="tbody" @end="endDragSupport" :move="checkMove"
            :style="moveItems ? 'pointer-events: none;' : ''">
            <tr v-for="(item, index) in props.items" :key="index" @click="goToEditSupport(item)">
              <td>
                <v-icon small style="cursor: pointer" :disabled="moveItems ? true : false">
                  mdi-menu
                </v-icon>
              </td>
              <td>{{ index + 1 }}</td>
              <td>
                <div class="d-flex align-center">
                  <v-icon v-if="item.isHidden" small> mdi-eye-off </v-icon>
                  <div v-else style="width: 24px"></div>
                  <div :style="item.isHidden ? 'margin-left: 8px' : ''">
                    {{ item.title }}
                  </div>
                </div>
              </td>
              <td>{{ item.phoneNumber }}</td>
              <td>{{ item.email }}</td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data: () => ({
    showInfo: false,
    x: null,
    y: null,

    supports: [],

    moveItems: false,
    selectedDrag: "",

    supportHeaders: [
      {
        text: "",
        sortable: false,
      },
      {
        text: "Порядок отображения",
        value: "",
        sortable: false,
      },
      {
        text: "Название контакта",
        sortable: false,
        value: "title",
      },
      {
        text: "Номер телефона",
        sortable: false,
        value: "phoneNumber",
      },
      {
        text: "Эл. почта",
        sortable: false,
        value: "email",
      },
    ],
  }),
  methods: {
    openInfo(e) {
      e.preventDefault();
      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },

    goToCreateSupport() {
      this.$router.push({ name: "SupportAppealCreate" });
    },

    goToEditSupport(item) {
      this.$router.push({ name: "SupportAppealEdit", params: { id: item.id } });
    },

    getSupports() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV5 + "/appeal/support/list", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
          params: { page: 1, limit: 100 },
        })
        .then((res) => {
          this.supports = res.data.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    endDragSupport(evt) {
      this.moveItems = true;
      this.$axios
        .put(
          this.$store.getters.apiAdminPanelV2 + "/appeal/support/sort",
          {
            appealSupportId: this.selectedDrag,
            index: evt.newIndex + 1,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.getSupports();
          this.moveItems = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
          this.moveItems = false;
        });
    },

    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id;
    },
  },
  created() {
    this.getSupports();
  },
};
</script>
<style lang="scss" scoped></style>